module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/hair-makeup-tile-a7b4f2414d5ca5d2ce4aa181bc6041bb.jpg";